export default function MiniChart({ type, data }) {
    const w = 520, h = 120, pad = 16;
    const max = Math.max(...data), min = Math.min(...data);
    const scaleX = (i) => pad + (i * (w - 2 * pad)) / (data.length - 1);
    const scaleY = (v) => pad + (h - 2 * pad) * (1 - (v - min) / (max - min || 1));


    if (type === 'bar') {
        const bw = (w - 2 * pad) / data.length - 6;
        return (
            <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-24">
                <defs>
                    <linearGradient id="barGrad" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#22d3ee" stopOpacity="0.7" />
                        <stop offset="100%" stopColor="#34d399" stopOpacity="0.7" />
                    </linearGradient>
                </defs>
                <rect x="0" y="0" width={w} height={h} fill="rgba(148,163,184,0.06)" rx="10" />
                {data.map((v, i) => {
                    const x = pad + i * ((w - 2 * pad) / data.length) + 3;
                    const y = scaleY(v);
                    const bh = h - pad - y;
                    return <rect key={i} x={x} y={y} width={bw} height={bh} fill="url(#barGrad)" rx="4" />;
                })}
            </svg>
        );
    }


    if (type === 'line') {
        const d = data.map((v, i) => `${i === 0 ? 'M' : 'L'} ${scaleX(i)} ${scaleY(v)}`).join(' ');
        return (
            <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-24">
                <defs>
                    <linearGradient id="lineGrad" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#22d3ee" stopOpacity="0.6" />
                        <stop offset="100%" stopColor="#34d399" stopOpacity="0.1" />
                    </linearGradient>
                </defs>
                <rect x="0" y="0" width={w} height={h} fill="rgba(148,163,184,0.06)" rx="10" />
                <path d={d} stroke="#22d3ee" strokeWidth="2" fill="none" />
                <path d={`${d} L ${scaleX(data.length - 1)} ${h - pad} L ${scaleX(0)} ${h - pad} Z`} fill="url(#lineGrad)" opacity="0.5" />
            </svg>
        );
    }
    if (type === "heatmap") {
        const size = 4; // 4x4 grid
        const cell = (w - 2 * pad) / size;
        return (
            <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-24">
                {Array.from({ length: size * size }).map((_, i) => {
                    const x = (i % size) * cell + pad;
                    const y = Math.floor(i / size) * cell + pad;
                    const intensity = data[i] || 0;
                    return (
                        <rect
                            key={i}
                            x={x}
                            y={y}
                            width={cell - 2}
                            height={cell - 2}
                            fill={`rgba(34,211,238,${0.2 + intensity * 0.8})`}
                        />
                    );
                })}
            </svg>
        );
    }
    if (type === "waveform") {
        return (
            <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-24">
                <polyline
                    fill="none"
                    stroke="#34d399"
                    strokeWidth="2"
                    points={data.map((v, i) =>
                        `${scaleX(i)},${scaleY(v)}`
                    ).join(" ")}
                />
            </svg>
        );
    }



    return (
        <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-24">
            <rect x="0" y="0" width={w} height={h} fill="rgba(148,163,184,0.06)" rx="10" />
            <polyline fill="none" stroke="#34d399" strokeWidth="2" points={data.map((v, i) => `${scaleX(i)},${scaleY(v)}`).join(' ')} />
        </svg>
    );
}